import parseHtml from "lib/parser";

export default function ParagraphBlock(props) {
  const { content } = props;

  return <p>{parseHtml(content)}</p>;
}
